import React from 'react';
import { Dialog, DialogContent, DialogDescription } from '@/components/ui/dialog';
import { DialogTitle } from '@radix-ui/react-dialog';
import { Button } from '@/components/ui/button';

export function PrintOptionsModal({ open, onOpenChange, onSelectQuestions, onSelectAnswerSheet }) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent
        size="sm"
        onClick={e => e.stopPropagation()}
      >
        <DialogTitle>Como deseja imprimir?</DialogTitle>
        <DialogDescription>Escolha o que será impresso.</DialogDescription>
        {/* flex-col explicito -- DialogFooter default vira flex-row a partir do
            breakpoint sm, e os labels sao longos o bastante pra causar rolagem
            lateral lado a lado. */}
        <div className="flex flex-col gap-2">
          <Button
            variant="outline"
            fullWidth
            onClick={onSelectQuestions}
          >
            Imprimir questões da prova
          </Button>
          <Button
            fullWidth
            onClick={onSelectAnswerSheet}
          >
            Imprimir cartões de resposta
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
